"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classTransformer_1 = require("../classTransformer");
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../Resource"));
class DocumentNotaryAnchor extends Resource_1.default {
}
exports.default = DocumentNotaryAnchor;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], DocumentNotaryAnchor.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DocumentNotaryAnchor.prototype, "document_notary_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DocumentNotaryAnchor.prototype, "file_hash", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DocumentNotaryAnchor.prototype, "blockchain", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], DocumentNotaryAnchor.prototype, "anchor_nb_try", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], DocumentNotaryAnchor.prototype, "anchored_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", Object)
], DocumentNotaryAnchor.prototype, "anchored_by_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", Object)
], DocumentNotaryAnchor.prototype, "tx_id", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", Object)
], DocumentNotaryAnchor.prototype, "tx_link", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", Object)
], DocumentNotaryAnchor.prototype, "tx_hash", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", Object)
], DocumentNotaryAnchor.prototype, "anchor_job_id", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Object)
], DocumentNotaryAnchor.prototype, "block_height", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], DocumentNotaryAnchor.prototype, "block_time", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Object)
], DocumentNotaryAnchor.prototype, "confirmations", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], DocumentNotaryAnchor.prototype, "proof_data", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], DocumentNotaryAnchor.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], DocumentNotaryAnchor.prototype, "updated_at", void 0);
